<template>
  <div class="container">
    <div class="block">
      <h1 class="title">{{ date }} Report</h1>
    </div>
    <div class="block">
      <span class="headline">Garena Mobile Games Daily Ranking</span>
      <product v-for="(productInfo, name) in report.productRankings" :key="name" :productInfo="productInfo" />
    </div>
    <div class="block">
      <span class="headline">AppStore, GooglePlay TOP10 Download & Grossing chart</span>
      <p><b>Top 10 New Entries: Unranked or Recently Added the Day Before</b></p>
      <table class="newGameTable">
        <tr class="newGameHeader">
          <th v-for="col in ['Region', 'Store', 'Chart Type', 'Rank', 'App Name', 'Publisher']">
            {{ col }}
          </th>
        </tr>
        <tr v-for="(newGame, index) in newGames" :key="index" class="newGameRow">
          <td>{{ newGame.region }}</td>
          <td>{{ newGame.platform }}</td>
          <td>{{ newGame.chartType }}</td>
          <td>#{{ newGame.ranking }}</td>
          <td>{{ newGame.appName }}</td>
          <td>{{ newGame.publisher }}</td>
        </tr>
      </table>
    </div>
    <div class="block">
      <region v-for="(regionInfo, name) in report.regionRankings" :key="name" :regionInfo="regionInfo" :regionKey="name" />
    </div>
    <div class="block">
      <DailySummary :summaries="report.summary" />
    </div>
  </div>
</template>

<script>
import DailySummary from './DailySummary.vue';
import Product from './Product.vue';
import Region from './Region.vue';

export default {
  name: 'Report',
  components: {
    DailySummary,
    Product,
    Region,
  },
  props: ['report', 'date'],
  computed: {
    newGames: function() {
      let newGames = [];
      const regionRankings = this.report.regionRankings;
      Object.keys(regionRankings).forEach(function(region) {
        const regionInfo = regionRankings[region];
        ['appStore', 'googlePlay'].forEach(function(storeType) {
          const storeMapping = {
            'appStore': 'App Store',
            'googlePlay': 'Google Play',
          }
          const typeMapping = {
            'free': 'Download',
            'grossing': 'Grossing',
          }

          const rankings = regionInfo[storeType];
          if (!rankings) {
            return;
          }

          Object.keys(rankings).forEach(function(type) {
            const ranking = rankings[type];
            ranking.forEach(function(appInfo, index) {
              if (appInfo.isNew) {
                newGames.push({
                  region: regionInfo.displayName,
                  platform: storeMapping[storeType],
                  chartType: typeMapping[type],
                  ranking: index+1,
                  appName: appInfo.appName,
                  publisher: appInfo.appPublisher,
                });
              }
            })
          })
        })
      })

      return newGames;
    }
  },
}
</script>

<style scoped>
.title {
  text-align: center;
}

.block {
  text-align: left;
  clear: left;
}

.headline {
  background-color: #c5c3cd;
  font-weight: bold;
}

.newGameTable {
  border-collapse: collapse;
  margin: 15px 0 10px 0;
  max-width: 95%;
}

.newGameHeader > th {
  background-color: bisque;
  text-align: center;
  border: 1px solid #ccc;
  border-spacing: 0px;
  padding: 5px;
  font-size: 16px;
  vertical-align: middle;
}

.newGameRow > td {
  border: 1px solid #ccc;
  border-spacing: 0px;
  padding: 5px;
  font-size: 16px;
  vertical-align: middle;
}

.newGameRow:nth-child(2n-1) {
  background-color: #ffe4c470;
}
</style>
